<div [@routerTransition] class="height-100pe">
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="row height-100pe">
    <div class="col-md-9 padding-right-5px">
      <div class="card my-profile-form margin-top-15px top-link margin-left-15px ">
        <div>
          <a class="nav-link-hand  back-link left-arrow-treatmentcycle" title="Back To Customer Orders" (click)="BackToOrders()"><i class="fas fa-angle-double-left font-size-19px"></i></a>
        </div>
        <div class="card-header wh-header  padding-bottom-6px padding-top-0px padding-left-15px">
          <div class="row border-bottom-1px">
            <div class="col-md-8 border-left-female padding-right-0px padding-left-10px padding-top-6px">

              <div class="row font-size-16px">
                <div class="col-md-5">
                  <label class="margin-bottom-0px">View Order </label>
                  <!--<a class="nav-link-hand font-size-16px" title="Back To Customer Orders" (click)="BackToOrders()">View Order</a>-->
                </div>


              </div>

              <!--<div class="row">
              <div class="col-md-1 margin-left-auto padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
                </div>
              <div class="col-md-1 padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
              </div>

               <div class="col-md-1 padding-left-7px">

                <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
              </div>

            </div>-->

            </div>
            <!--<div class="col-md-5 float-right margin-bottom-3px">
            <button class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 float-right" (click)="Payment()">Back</button>
          </div>-->
            <!--<div class="col-md-8 padding-right-0px">
            <div class="row">
              <div class="offset-md-6 col-md-2 padding-right-0px text-align-center">
                <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
              </div>
              <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
                <form novalidate="" #f="ngForm" class="display-inherit">
                  <div class="clear-form">
                    <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                    <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                  </div>
                  <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
                </form>
              </div>
            </div>
          </div>-->
          </div>
          <div class="row">
            <div class="col-md-8  padding-right-0px padding-left-0px">
              <div class="row font-size-14">
                <div class="col-md-2 text-align-right">
                  <label class="margin-bottom-0px">Customer </label>
                </div>:
                <div class="col-md-4 padding-right-0px padding-left-10px">
                  <label class="color-Checkin margin-bottom-0px">Piyali Sarkar, 8106220988</label>
                </div>

              </div>

              <!--<div class="row">
              <div class="col-md-1 margin-left-auto padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
                </div>
              <div class="col-md-1 padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
              </div>

               <div class="col-md-1 padding-left-7px">

                <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
              </div>

            </div>-->

            </div>

            <div class="offset-md-1 col-md-3 text-align-right">

              <label class="color-Assign margin-bottom-0px">#12344</label>


            </div>
          </div>
          <div class="row border-bottom-1px">
            <div class="col-md-8  padding-right-0px padding-left-0px">
              <div class="row font-size-14">
                <div class="col-md-2 text-align-right">
                  <label class="margin-bottom-0px">Deliver To </label>
                </div>:
                <div class="col-md-4 padding-right-0px padding-left-10px">
                  <label class="color-checkout margin-bottom-0px">Nacharam, Hyd</label>
                </div>

              </div>

              <!--<div class="row">
              <div class="col-md-1 margin-left-auto padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
                </div>
              <div class="col-md-1 padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
              </div>

               <div class="col-md-1 padding-left-7px">

                <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
              </div>

            </div>-->

            </div>

            <div class="offset-md-1 col-md-3 text-align-right">

              <label class="margin-bottom-0px font-weight-normal  font-size-14">OCT-12-2020 9:50PM</label>


            </div>
          </div>
          <div class="row border-bottom-1px">
            <div class="col-md-3  padding-right-0px padding-left-0px">
              <div class="row font-size-14 margin-top-10">
                <div class="col-md-4 text-align-right padding-left-0px">
                  <label class="margin-bottom-0px">Status </label>
                </div>:
                <div class="col-md-7  padding-left-10px my-profile-form">

                  <div class="form-group margin-bottom-0px">
                    <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                    <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                  [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                  name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                    <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">Dispatched</h4>


                  </div>


                </div>

              </div>

              <!--<div class="row">
              <div class="col-md-1 margin-left-auto padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
                </div>
              <div class="col-md-1 padding-left-7px">
                <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
              </div>

               <div class="col-md-1 padding-left-7px">

                <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
              </div>

            </div>-->

            </div>
            <div class="col-md-9">
              <div class="row margin-top-10 margin-bottom-10">
                <div class="max-width-12pe">
                  <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="EditItem2()">Update Status</button>
                </div>
                <div>
                  <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="ViewOrder()">Generate Bill</button>
                </div>

                <div>
                  <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="ViewOrder()">Open Bill</button>
                </div>


              </div>
            </div>
            <!--<div class="col-md-8 padding-right-0px">
            <div class="row">
              <div class="offset-md-6 col-md-2 padding-right-0px text-align-center">
                <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
              </div>
              <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
                <form novalidate="" #f="ngForm" class="display-inherit">
                  <div class="clear-form">
                    <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchValue" name="searchBar" [value]='searchValue' maxlength="15">
                    <a (click)="ClearInput()" class="nav-link-hand" title="Clear" *ngIf="searchValue!=null"><span class="clear-icon"><i class="fa fa-times"></i></span></a>
                  </div>
                  <button (click)="criteriaChange(searchValue)" class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
                </form>
              </div>
            </div>
          </div>-->
          </div>
        </div>
        <div class="card-body padding-top-0px margin-left-0px padding-left-0px padding-right-0px">
          <div class="card">
            <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px background-color">
              <div class="row nav-link-hand margin-right-0px margin-left-0px">
                <div class="col-md-6 padding-right-0px">
                  <label class="margin-bottom-0px font-size-16px font-weight-normal margin-left-5px">
                    Items List
                  </label>
                </div>
                <div class="col-md-6  padding-right-0px">
                  <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->

                  <div class="row">
                    <!--<div class="offset-md-2 col-md-1 padding-right-8px">
                    <button class="btn actions-btn-prime font-size-13px margin-left-5px float-right" (click)="ViewOrder()">
                      Save
                    </button>
                  </div>-->
                    <div class="col-md-4  padding-right-0px padding-l-0px display-inherit">
                      <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                    </div>
                    <div class=" col-md-3  padding-right-0px padding-l-0px">
                      <div class="row font-size-16px margin-top-3px">
                        <div class="col-md-7  text-align-right padding-right-10px">
                          <label class="font-weight-bold  margin-bottom-0px"> Bill Total </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px">
                          <h4 class="font-weight-bold color-Assign margin-bottom-0px margin-top-4px font-size-16px">100</h4>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2 float-right padding-left-0px">
                      <a class="nav-link-hand education-navlink data-color-new float-right margin-top-5px" title="print">
                        <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                      </a>
                    </div>

                  </div>



                </div>

              </div>
            </div>
            <div class="card-body padding-top-0px padding-right-0px">
              <div class="row">
                <div class="col-md-12 padding-left-0px padding-right-0px">
                  <div class="table-component">
                    <div class="table-responsive overflow-x">


                      <table class="table table-striped margin-left-zero"
                             cols="auto,2*,*,*,*,*,*,*">

                        <thead class="">
                          <tr>

                            <th class="min-width-24px padding-top-4px padding-bottom-4px">
                              #
                            </th>

                            <th class="padding-top-4px padding-bottom-4px">
                              Item Name
                            </th>
                            <th class="padding-top-4px padding-bottom-4px padding-right-0px">
                              Requst Qty
                            </th>
                            <th class="padding-top-4px padding-bottom-4px">
                              Pack
                            </th>
                            <th class="padding-top-4px padding-bottom-4px padding-right-2px">
                              Unit Price
                            </th>
                            <th class="padding-top-4px padding-bottom-4px padding-right-2px">
                              UOM
                            </th>
                            <th class="padding-top-4px padding-bottom-4px padding-right-0px">Issue Qty</th>

                            <th class="padding-top-4px padding-bottom-4px padding-right-5px">Amount </th>
                            <th class="padding-top-4px padding-bottom-4px padding-left-8px">Comments</th>

                            <th></th>


                          </tr>
                        </thead>

                        <tbody class="table-body">
                          <tr>

                            <td class="td-padding-tb">1 </td>



                            <td class=" td-padding-tb">Consultant</td>




                            <td class="td-padding-tb padding-right-21px text-align-right padding-left-0px">2</td>
                            <td class=" td-padding-tb">New</td>
                            <td class="td-padding-tb text-align-right padding-right-21px">100</td>


                            <td class="td-padding-tb padding-right-16px text-align-right">3</td>
                            <td class="td-padding-tb padding-right-21px text-align-right">100</td>
                            <td class="td-padding-tb padding-right-16px text-align-right">3</td>
                            <td class="padding-right-0px">
                              <!--<div class="form-group margin-bottom-0px">
                              <CodeTypeValue CodeType="FNSTS"
                                             id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                                             [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
                                             name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">

                              </CodeTypeValue>



                            </div>-->
                              New One
                            </td>
                            <td class="td-padding-tb">

                              <button type="submit" (click)="EditItem()" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Save"><i class="fas fa-pencil-alt"></i></button>




                            </td>



                          </tr>

                        </tbody>

                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    
    <div class="col-md-3 padding-left-5px padding-right-0px">
      <div class="row height-100pe background-primary margin-left-0px">
        <div class="position-fixed-Activities">

          <div class="col-md-12 padding-left-0px padding-right-0px">
            <div class="card">
              <div class="card-header border-left-clinical font-size-16px border-top-1px border-right-1px border-bottom-1px border-radius-5px wh-header padding-top-3px padding-bottom-3px padding-right-0px padding-left-9px">
                Order Status Details
              </div>
              <div class="card-body padding-all-0px">
                <div class="row margin-top-0px margin-left-0px">
                  <div class="col-md-12 padding-left-8px margin-top-5px">
                    <div class="row">
                      <div class="col-md-11 padding-left-19px">


                        


                        <div class="message-sender2">

                          <div class="row border-left-8px-cycle margin-left-0px">
                            <div class="col-md-12 margin-top-4px  font-size-13px text-align-justify">
                              <div class="row ">
                                <div class="col-md-8 padding-left-5px padding-right-0px">
                                  <label class="margin-bottom-0px">OCT-23-2020</label>
                                </div>
                                <div class="col-md-4 padding-left-0px padding-right-7px text-align-right">
                                  <label class="margin-bottom-0px">Pavan</label>
                                </div>
                              </div>

                              <div class="row ">
                                <div class="col-md-12 padding-left-5px">
                                  <label class="margin-bottom-0px color-checkout font-weight-bold">Accepted</label>
                                </div>
                              </div>

                              <!--<div class="row ">
                <div class="col-md-12 padding-left-5px">
                  <label class="margin-bottom-0px">Dosage Form : {{l.DosageForm}}</label>
                </div>
              </div>-->
                              <div class="row ">
                                <div class="col-md-12 padding-left-5px">
                                  <label class="margin-bottom-0px font-size-12px"><i>New One</i></label>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  

</div>



